module.exports = __webpack_public_path__ + "img/linkedin.833286f8.svg";